module.exports = __webpack_public_path__ + "static/img/coin-off.b63fc006.png";